
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useRfmRecency } from '@/modules/rfm/recency/model/edit';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';

export default defineComponent({
    name: ROUTE_NAME_RFM.RECENCY.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, rfmGroupOptions, fetchRfmGroupAll, actions } = useRfmRecency();

        onMounted(async () => {
            await fetchRfmGroupAll();
        });

        return { v$, model, rfmGroupOptions, actions };
    }
});
